import {
  LOAD_COMMENTS_DATA,
  POST_COMMENT,
  LOAD_REPLY_COMMENTS_DATA,
  LOAD_APPEND_COMMENTS_DATA,
  LOAD_MORE_REPLY_COMMENTS_DATA,
  POST_REPLY_COMMENT,
  POST_LIKE_COMMENT,
} from './constants';

export function loadCommentsData(params) {
  return { type: LOAD_COMMENTS_DATA, payload: params };
}
export function appendCommentsData(params) {
  return { type: LOAD_APPEND_COMMENTS_DATA, payload: params };
}

export function postComment(params) {
  return { type: POST_COMMENT, payload: params };
}

export function appendReplyCommentData(params) {
  return { type: LOAD_REPLY_COMMENTS_DATA, payload: params };
}
export function appendMoreReplyCommentData(params) {
  return { type: LOAD_MORE_REPLY_COMMENTS_DATA, payload: params };
}

export function postReplyComment(params) {
  return { type: POST_REPLY_COMMENT, payload: params };
}

export function postLikeComment(params) {
  return { type: POST_LIKE_COMMENT, payload: params };
}
